import { ADMIN_NEW_GLOBAL_PERMISSIONS } from '@confluence/named-routes/entry-points/routes';

export const getAdminDataSecurityPolicyUrl = (environment: string, orgId: string) =>
	environment === 'PRODUCTION'
		? `https://admin.atlassian.com/o/${orgId}/data-security-policies`
		: `https://admin.stg.atlassian.com/o/${orgId}/data-security-policies`;

export const getAdminGlobalPermsPublicLinksUrl = (spaceId?: string) =>
	spaceId
		? `${ADMIN_NEW_GLOBAL_PERMISSIONS.toUrl()}?tab=public-links&space=${spaceId}`
		: `${ADMIN_NEW_GLOBAL_PERMISSIONS.toUrl()}?tab=public-links`;

export const getPublicLinksSpaceSettingsBlockedStateUrl = ({
	isSpaceBlockedByOrg,
	environment,
	orgId,
}) =>
	isSpaceBlockedByOrg
		? getAdminDataSecurityPolicyUrl(environment, orgId)
		: getAdminGlobalPermsPublicLinksUrl();
